<template>
  <div
    class="ms-radio"
    :tabindex="disabled?-1:0"
    @keypress="keyDownActive"
    @focus="onFocus"
    @blur="onBlur"
  >
    <label :class="['pointer',cssLabel]">
      <input
        type="radio"
        :name="name"
        :value="keyValue"
        :checked="value"
        v-model="value"
        tabindex="1"
        @input="$emit('input',keyValue)"
        @change="$emit('change',$event)"
        :disabled="disabled"
      >
      <span class="checkmark-btn whitespace-no-wrap" v-if="type=='button'">
        <span v-if="title" class="ml-2" :class="[cssTitle]">{{title}}</span>
      </span>
      <span
        class="checkmark"
        v-if="type=='radio'"
        :class="[{'disabled':disabled},{'focused':focused}]"
      ></span>
      <span v-if="title && type!='radio'"  class="ml-2 text-title" :class="[cssTitle]">{{title}}</span>
      <slot></slot>
    </label>
  </div>
</template>
<script>
export default {
	name: 'msRadio',
	props: {
		value: {},
		title: {
			default: null,
			type: String
		},
		keyValue: {
			default: null
		},
		name: {
			default: null,
			type: String
		},
		type: {
			default: 'radio',
			type: String
		},
		cssLabel: {
			default: null,
			type: String
		},
		cssTitle: {
			default: null,
			type: String
		},
		disabled: {
			default: false,
			type: Boolean
		},
		tabindex: {
			default: 0,
			type: Number
		}
	},
	methods: {
		keyDownActive(e) {
			event.preventDefault();
			switch (e.which) {
				case 32:
				case 13:
					this.$emit('input', this.keyValue);
					break;
			}
		},
		onFocus(e) {
			const me = this;
			me.focused = true;
			me.$emit('focus', e);
		},
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
		}
	},
	computed: {
		listeners() {
			return {
				...this.$listeners
			};
		}
	},
	data() {
		return {
			focused: false
		};
	},
	watch: {}
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msRadio.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msRadio.scss';
}
</style>

